import React from 'react';

function Main() {
  return (
    <div style={{ textAlign: 'center' }}>
      <h3>Obrigado, sua denúncia foi enviada!</h3>
    </div>
  );
}
export default Main;
